

import BaseRouter from './Base.js';
import Log from 'lib/log';
import BulkUploads from 'newCollections/bulk-uploads.js';
import Employees from 'newCollections/employees.js';
import Payrolls from 'newCollections/payrolls.js';
import PayrollItems from 'newCollections/payroll-items.js';
import TimesheetView from '../views/timesheet/Layout.js';
import TimesheetUploadView from '../views/timesheet/TimesheetUpload';
import moment from 'moment';
import loader from 'helpers/loader.js';

const log = Log('employer/timesheet-router');

module.exports = BaseRouter.extend({
    routes: {
        'timesheet(/:date)': 'timesheet',
        'timesheet-upload': 'timesheetUpload'
    },

    titles: {
        'timesheet(/:date)': 'Timesheet',
        'timesheet-upload': 'TimesheetUpload'
    },

    initialize(options) {
        this.options = _.defaults(options || {}, {log: log});
        BaseRouter.prototype.initialize.apply(this, [this.options]);
    },

    timesheet(date) {
        date = !date ?
            moment().startOf('week') :
            moment(date, 'DD-MM-YYYY').startOf('week');

        const employees = new Employees(null, {
            sortKey: 'canonicalFullName',
            sortOrder: 'ascending',
            pagination: {rowsPerPage: 5},
            company: app.company,
            filter: {
                where: {
                    and: [
                        {commencementDate: {neq: null}},
                        {commencementDate: {lte: moment(date).endOf('week')}}
                    ],
                    or: [
                        {hiddenAt: null},
                        {
                            and: [
                                {cessationDate: {neq: null}},
                                {cessationDate: {
                                    gte: moment(date).startOf('week')
                                }}
                            ]
                        }
                    ]
                }
            }
        });

        const stopLoader = loader.startFullScreen(this.$el);
        const overtimeItems = app.payrollItems.chain().filter(
            item => {
                return (!item.get('hiddenAt') &&
                    (item.get('type') === 'overtime'));
            }
        ).sortBy(
            item => (new Date(item.get('createdAt')).getTime()) * -1
        ).value();
        const payrolls = new Payrolls(null, {
            company: app.company,
            sortKey: 'createdAt',
            sortOrder: 'descending'
        });

        return payrolls.fetch({
            filter: {where: {status: {lte: 2}}}
        }).then(() => {
            let unsubmittedPayroll = null;
            if (payrolls.length > 0) {
                unsubmittedPayroll = payrolls.at(0);
            }
            this.view = new TimesheetView({
                el: this.el,
                collection: employees,
                overtimeItems: new PayrollItems(
                    overtimeItems, {company: app.company}
                ),
                unsubmittedPayroll: unsubmittedPayroll,
                date: date.toDate()
            }).render();
        }).finally(stopLoader);
    },

    timesheetUpload() {
        const stopLoader = loader.startFullScreen(this.$el);
        new BulkUploads(null, {company: app.company})
            .fetch({where: {status: {neq: 'done'}}})
            .then(pendingUploads => {
                const view = new TimesheetUploadView({
                    model: pendingUploads.at(0)
                });
                $(this.el).html(view.render().el);
            })
            .finally(stopLoader);
    }
});



// WEBPACK FOOTER //
// ./app/employer/routers/Timesheet.js